<script lang="ts">
  let props = $props()
  let { options, annual_vision, quarterly_vision } = props
</script>

<div class="px-6 my-4">
  <h2 class="mt-4 text-center text-2xl font-bold">
    Annual Vision for {options.fiscal_year}
  </h2>

  <div
    class="my-2 bg-gray-50 p-4 max-h-80 overflow-y-auto border border-gray-200 rounded ProseMirror"
  >
    {#if annual_vision && annual_vision.vision.length > 0}
      {@html annual_vision.vision}
    {:else}
      No Annual Vision set for this period.
    {/if}
  </div>
  <h2 class="mt-6 text-center text-2xl font-bold">
    Quarterly Vision for Q{options.quarter}
    {options.fiscal_year}
  </h2>
  <div
    class="my-2 bg-gray-50 p-4 max-h-80 overflow-y-auto border border-gray-200 rounded ProseMirror"
  >
    {#if quarterly_vision && quarterly_vision.vision.length > 0}
      {@html quarterly_vision.vision}
    {:else}
      No Quarterly Vision set for this period.
    {/if}
  </div>
</div>
